const params = {
  tokenAccess: process.env.REACT_APP_TOKEN_ACCESS,
  fzdomain: process.env.REACT_APP_FZ_DOMAIN,
  fzlogo: process.env.REACT_APP_FZ_LOGO,
  fzLoadingImage: process.env.REACT_APP_FZ_LOADING_IMAGE,
  fzCheckerImage: process.env.REACT_APP_FZ_CHECKER_IMAGE,
  fzSharingApi: process.env.REACT_APP_FZ_SHARING_API,
  scanUrl: process.env.REACT_APP_SCAN_URL,
  verificationServer: process.env.REACT_APP_VERIFICATION_SERVER,
  t05TestPaymentUrl: process.env.REACT_APP_T05_TEST_PAYMENT_URL,
  fzTestPaymentUrl: process.env.REACT_APP_FZ_TEST_PAYMENT_URL,
  eghlPaymentUrl: process.env.REACT_APP_EGHL_PAYMENT_URL,
  eghlMerchantTermUrl: process.env.REACT_APP_EGHL_MERCHANT_TERM_URL,
  ipay88PaymentUrl: process.env.REACT_APP_IPAY88_PAYMENT_URL,
  pineAppleRoundImage: process.env.REACT_APP_PINEAPPLE_ROUND_IMAGE,
  pineAppleLogo: process.env.REACT_APP_PINEAPPLE_LOGO,
  pineAppleMemberApi: process.env.REACT_APP_PINEAPPLE_MEMBER_API,
  googleMapUrl: process.env.REACT_APP_GOOGLE_MAP_URL,
  spotMicroJs: process.env.REACT_APP_SPOT_MICRO_JS,
  unisoln_controller: process.env.REACT_APP_UNISOLN_CONTROLLER,
  recomendCacheUrl: process.env.REACT_APP_RECOMMEND_CACHE_URL,
  postalApi: process.env.REACT_APP_POSTAL_API,
  postalApiKey: process.env.REACT_APP_POSTAL_API_KEY,
  postalApiSecret: process.env.REACT_APP_POSTAL_API_SECRET,
  dbaRedirectPaymentUrl: process.env.REACT_APP_DBA_REDIRECT_PAYMENT_URL,
  adyenRedirectPaymentUrl: process.env.REACT_APP_ADYEN_REDIRECT_PAYMENT_URL,
  eberRedirectUrl: process.env.REACT_APP_EBER_REDIRECT_URL,
  eberRewardsUrl: process.env.REACT_APP_EBER_REWARDS_URL,
  eberProfileUrl: process.env.REACT_APP_EBER_PROFILE_URL,
  bwProfileUrl: process.env.REACT_APP_BW_PROFILE_URL,
  rewardImage: process.env.REACT_APP_REWARD_IMAGE,
  apiAddOrder: process.env.REACT_APP_API_ADD_ORDER,
  apiOrder: process.env.REACT_APP_API_ORDER,
  apiMenu: process.env.REACT_APP_API_MENU,
  advocadoRewardsUrl: process.env.REACT_APP_ADVOCADO_REWARDS_URL,
  advocadoTokenUrl: process.env.REACT_APP_ADVOCADO_TOKEN_URL,
  advocadoBaseUrl: process.env.REACT_APP_ADVOCADO_BASE_URL,
  advocadoCustomerUrl: process.env.REACT_APP_ADVOCADO_CUSTOMER_URL,
  emailConfig: process.env.REACT_APP_EMAIL_CONFIG,
};

export default params;
